import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import { nowVassDetailState } from "../../stores/vass/nowVassDetailState";
import { prevVassDetailState } from "../../stores/vass/prevVassDetailState";
import Swal from "sweetalert2";
import { useGetTracking } from "../barcode/useGetTracking";
import { useEffect, useState } from "react";
import { useGetVideoList } from "./useGetVideoList";
import { videoListState } from "../../stores/vass/videoListState";

// TODO 영상추적 조회 값 설정 API
const useGetVassSeconds = (searchInvoice, searchDate, searchTaskType) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setNowVassDetail = useSetRecoilState(nowVassDetailState); // 현재 운송장 번호
  const setPrevVassDetail = useSetRecoilState(prevVassDetailState); // 이전 운송장 번호
  const [trackingValue, setTrackingValue] = useState(""); // 화물추적 운송장 조회정보
  const setVideoList = useSetRecoilState(videoListState); // CCTV 동영상 리스트

  const instanceMap = {
    LOGEN: LogenInstance,
    LOTTE: LotteInstance,
    HANJIN: HanjinInstance,
    HANDEX: HandexInstance,
  };

  const apiInstance = instanceMap[login.company];

  // TODO 화물추적 API
  const { mutate: getTracking } = useGetTracking(trackingValue);
  
  // TODO CCTV 동영상 데이터 조회 API
  const { mutate: videoListMutate } = useGetVideoList(setVideoList);

  // NOTE 화물추적 운송장 조회정보(Vass 운송장 번호)가 존재한다면
  useEffect(() => {
    if (trackingValue) {
      getTracking(); 
      videoListMutate();
    }
  }, [trackingValue, getTracking, videoListMutate]);

  // TODO API 정보
  return useMutation({
    mutationFn: async () => {
      if (!apiInstance) throw new Error("Invalid company");

      return apiInstance.post("/lose", {
        api: "barcodeTime",
        data: [
          {
            bran_cd: login.branchCode,
            barcode: searchInvoice?.toString(),
            scandate: searchDate,
            taskType: searchTaskType,
            second: "0",
          },
        ],
      });
    },
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00") {
        const nowBarcodeIndex = data.data.findIndex(
          (vass) => vass.barcode === searchInvoice?.toString()
        );
        setNowVassDetail(data.data[nowBarcodeIndex]);
        setPrevVassDetail(data.data[nowBarcodeIndex].prev_barcode);

        setTrackingValue(data.data[nowBarcodeIndex].prev_barcode); // 화물추적, 영상추적 변수가 있을 시 useEffect 동작
      } else if (data.result === "04") {
        Swal.fire({
          icon: "warning",
          title: "유효하지 않은 운송장 번호입니다!",
          text: "운송장 번호를 확인해주세요.",
          confirmButtonText: "확인",
        });
      } else if (data.result === "10") {
        Swal.fire({
          icon: "warning",
          title: "운송장 번호를 입력해주세요.",
          confirmButtonText: "확인",
        });
      }
    },

    // 실패 시
    onError: (error) => {
      console.log(error);
    },
  });
};

export default useGetVassSeconds;
